import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import ToastrAction from 'toastr/actions/ToastrAction'
import Checkbox from '../../../../components/forms/Checkbox'
import Select from '../../../../components/forms/Select'
import { nbPerPageLabelTiny } from '../../../../referencial/constants/ReferencialConstants'
import Job from '../../../dto/DtoJob'
import IntegrationModeDialog from '../IntegrationModeDialog'
import { CITIES, DEPARTMENTS, STATIONS } from 'traitements/constants/TraitementConstants'
import RadioButtons from 'components/forms/RadioButtons'
import { CardTable } from 'components/datatable/NewTable'
import { Button, Grid } from '@mui/material'
import { exportFile } from 'utils/ExportDataUtil'
import { darkBlue, mainWhite } from 'utils/constants/ColorTheme'
import AppStore from 'store/AppStore'

class ImportLowWaterPanel extends Component {
    constructor(props) {
        super(props)
        this.state = {
            obsOptions: [
                {
                    value: '',
                    label: i18n.noDataIntegration,
                },
                {
                    value: 'dataIntegration',
                    label: i18n.lastDataIntegration,
                },
                {
                    value: 'dataFullIntegration',
                    label: i18n.fullDataIntegration,
                },
            ],
        }
    }

    componentDidMount() {
        this.onChangeFilters({})
    }

    getFilters() {
        const { parameters } = this.props.job
        const filters = (parameters.filters && parameters.filters.length) ? parameters.filters : ['{\"codeMode\":\"stations\",\"codes\":[],\"stationIntegration\":false,\"dataIntegration\":\"\"}']
        return JSON.parse(filters[0])
    }

    onChangeFilters = (changes) => {
        const parameters = {
            ...this.props.job.parameters,
            filters: [JSON.stringify({
                ...this.getFilters(),
                ...changes,
            })],
        }
        this.props.onChangeJob({ parameters })
    }

    stationIntegration() {
        const { parameters } = this.props.job
        if (parameters.filters && parameters.filters.length) {
            return JSON.parse(parameters.filters).stationIntegration || false
        }
        return false
    }

    dataIntegration() {
        const { parameters } = this.props.job
        if (parameters.filters && parameters.filters.length) {
            return JSON.parse(parameters.filters).dataIntegration || ''
        }
        return ''
    }

    handleChangeStationIntegration = integration => {
        const filters = this.getFilters()
        const newFilters = { ...filters, stationIntegration: integration }
        this.onChangeFilters([JSON.stringify(newFilters)])
    }

    handleChangeDataIntegration = integration => {
        const filters = this.getFilters()
        const newFilters = { ...filters, dataIntegration: integration }
        this.onChangeFilters([JSON.stringify(newFilters)])
    }

    addCode = () => {
        const filters = this.getFilters()
        const code = this.refs.txtAddBssCode.value
        const exist = this.props.job.parameters.parameters.find(p => p.toLowerCase() === code.toLowerCase())
        if (this.props.isEditMode) {
            if (filters.stationsMode === STATIONS) {
                if (!code) {
                    AppStore.dispatch(ToastrAction.error(i18n.youMustEnterAtLeastOneBssCode))
                } else if (exist) {
                    AppStore.dispatch(ToastrAction.error(i18n.youHaveAlreadyEnteredThisBssCode))
                } else {
                    this.props.addCode([code, ...this.props.job.parameters.parameters])
                    this.refs.txtAddBssCode.value = ''
                }
            } else if (!code) {
                AppStore.dispatch(ToastrAction.error(i18n.youMustEnterAtLeastOneBssCode))
            } else if (exist) {
                AppStore.dispatch(ToastrAction.error(i18n.youHaveAlreadyEnteredThisBssCode))
            } else {
                this.onChangeFilters({ codes: [code, ...(filters.codes ?? [])] })
                this.refs.txtAddBssCode.value = ''
            }
        }
    }
    getStations = (filters) => {
        return (filters.codes || []).map((v) => ({ credentials: v }))
    }

    onDeleteCode = ({ credentials }) => {
        const filters = this.getFilters()
        this.onChangeFilters({ codes: filters.codes.filter(p => p !== credentials) })
    }

    render() {
        const filters = this.getFilters()
        const codesTypes = [
            { code: STATIONS, name: i18n.stations },
            { code: CITIES, name: i18n.cities },
            { code: DEPARTMENTS, name: i18n.departments },
        ]
        const disabled = !this.props.isEditMode
        const myData = this.getStations(filters)
        return (
            <>
                <Grid container pb={2} size={12}>
                    <Grid size={3}>
                        <Checkbox
                            checked={ this.stationIntegration() }
                            label={ i18n.integrateStationInfo }
                            onChange={ this.handleChangeStationIntegration }
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={4}>
                        <Select
                            value={ this.dataIntegration() }
                            options={ this.state.obsOptions }
                            label={ i18n.dataIntegration }
                            labelSpan={ <IntegrationModeDialog /> }
                            onChange={ this.handleChangeDataIntegration }
                            disabled={ disabled }
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2} size={12}>
                    <Grid size={2}>
                        <label>{ i18n.addCredential }</label>
                    </Grid>
                    <Grid size={4}>
                        <input
                            id='txtAddBssCode'
                            type='text'
                            placeholder={ i18n.BSSExample }
                            ref='txtAddBssCode'
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={6}>
                        <Button
                            onClick={ this.addCode }
                            disabled={ disabled }
                            variant='contained'
                        >
                            { i18n.add }
                        </Button>
                    </Grid>

                    <Grid size={4}>
                        <RadioButtons
                            elements={codesTypes}
                            selected={filters.codeMode}
                            onChange={v => this.onChangeFilters({ codeMode: v })}
                            disabled={ disabled }
                            title={i18n.schemeAgencyID}
                        />
                    </Grid>
                </Grid>
                <Grid size={12}>
                    <CardTable
                        headers={ ['credentials'] }
                        rows={ myData }
                        title={ filters.codeMode === STATIONS ? i18n.credentials : i18n[filters.codeMode] }
                        rowsPerPageOptions={ nbPerPageLabelTiny }
                        lineActions={[
                            { icon: 'delete', onClick: this.onDeleteCode, displayed: this.props.isEditMode },
                        ]}
                        actions={[{
                            icon: 'download',
                            onClick: () => exportFile({
                                data: [{ ...(myData[0]), headers: ['credentials'] }, ...(myData.slice(1, myData.length))],
                                titleFile: i18n.credentials,
                            }),
                            color: mainWhite,
                            tooltip: i18n.download,
                        }]}
                        exportButtonOnHeader
                        color={darkBlue}
                    />
                </Grid>
            </>
        )
    }
}

ImportLowWaterPanel.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    addCode: PropTypes.func.isRequired,
    onChangeJob: PropTypes.func,
    isEditMode: PropTypes.bool,
    handleChangeParameters: PropTypes.func.isRequired,
    toastrError: PropTypes.func,
}

const mapDispatchToProps = {
    toastrError: ToastrAction.error,
}

export default connect(null, mapDispatchToProps)(ImportLowWaterPanel)
